module.exports = __webpack_public_path__ + "img/dr-Rafal-R-Suszek.ccf92bed.jpg";